import type { SVGProps } from 'react';
const SvgMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path d="M17.1429 11C8.53378 11 13.0401 11 6.85714 11C6.38384 11 6 11.3838 6 11.8571V12.7143C6 13.1876 6.38384 13.5714 6.85714 13.5714C13.6814 13.5714 10.3186 13.5714 17.1429 13.5714C17.6162 13.5714 18 13.1876 18 12.7143V11.8571C18 11.3838 17.6162 11 17.1429 11Z" />
  </svg>
);
export default SvgMinus;
